export function pxToEm(pxValue, baseFontSize = 17.78) {
    // px 값을 em 값으로 변환
    const emValue = pxValue / baseFontSize;
    return `min(${pxValue}px, ${emValue.toFixed(4)}rem)`; // 소수점 아래 4자리까지 표시
  }